import type { MeetingActionItemsProps } from './MeetingActionItems.tsx';
import {
  addMeetingActionItem,
  deleteMeetingActionItem,
  updateMeetingActionItem,
} from '@/lib/meetingPage.ts';

export type MeetingActionItemHandlers = Pick<
  MeetingActionItemsProps,
  'onToggle' | 'onEdit' | 'onAdd' | 'onDelete'
>;

/** What both documents do to the agreements under them, through the page's one write. */
export function meetingActionItemHandlers(
  userId: string,
  meetingId: string,
  run: (task: () => Promise<void>) => void,
): MeetingActionItemHandlers {
  return {
    onToggle: (itemId, done) =>
      run(() => updateMeetingActionItem(userId, meetingId, itemId, { done })),
    onEdit: (itemId, text) =>
      run(() => updateMeetingActionItem(userId, meetingId, itemId, { text })),
    onAdd: (text) => run(() => addMeetingActionItem(userId, meetingId, text)),
    onDelete: (itemId) => run(() => deleteMeetingActionItem(userId, meetingId, itemId)),
  };
}
